import {
  Alert,
  Box,
  CircularProgress,
  Typography
} from "@mui/material";

import WeekPicker from "../../../../components/WeekPicker";
import { CONVERSATION_LENSES } from "../../../../utils/terminology";
import { useWizardStore } from "../../store/wizardStore";

interface SelectWeekProps {
  isCheckingData: boolean;
  showNoLensesWarning: boolean;
}

const SelectWeek = ({
  isCheckingData,
  showNoLensesWarning
}: SelectWeekProps) => {
  const { weekStart, setWeekRange } = useWizardStore();

  return (
    <Box>
      <WeekPicker
        value={weekStart}
        onChange={setWeekRange}
        label="Week"
        subtitle="Select a week"
      />

      {isCheckingData && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}>
          <CircularProgress size={16} />
          <Typography variant="body2" color="text.secondary">
            Checking data availability...
          </Typography>
        </Box>
      )}

      {showNoLensesWarning && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          <Typography variant="body2">
            No {CONVERSATION_LENSES.toLowerCase()} available for the selected week.
            Please try a different week.
          </Typography>
        </Alert>
      )}
    </Box>
  );
};

export default SelectWeek;
